import { router } from 'expo-router';
import { useEffect, useRef } from 'react';
import { Platform } from 'react-native';
import {
  addNotificationReceivedListener,
  addNotificationResponseListener,
} from '../lib/pushNotifications';

export function useNotificationListeners() {
  const responseListener = useRef<ReturnType<typeof addNotificationResponseListener> | null>(null);
  const receivedListener = useRef<ReturnType<typeof addNotificationReceivedListener> | null>(null);

  useEffect(() => {
    if (Platform.OS === 'web') return;

    receivedListener.current = addNotificationReceivedListener((notification) => {
      if (__DEV__) {
        console.log('Notification received in foreground:', notification.request.content.title);
      }
    });

    responseListener.current = addNotificationResponseListener((response) => {
      const data = response.notification.request.content.data;

      if (data?.leadId && typeof data.leadId === 'string') {
        router.push(`/lead/${data.leadId}` as any);
      }
    });

    return () => {
      receivedListener.current?.remove();
      responseListener.current?.remove();
    };
  }, []);
}
